import PropTypes from "prop-types"
import { Spinner, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"

const Loading = ({
  message = "Loading...",
  spinner = true,
  textColor = colors.neutral_600,
  ...props
}) => {
  return (
    <StackView distribution="center" alignment="center" spacing={2}>
      {spinner && <Spinner size={props.size || "xl"} thickness={3} {...props} />}
      {message && <Text color={textColor}>{message}</Text>}
    </StackView>
  )
}

Loading.propTypes = {
  message: PropTypes.string,
  size: PropTypes.string,
  spinner: PropTypes.bool,
  textColor: PropTypes.string
}

export default Loading
